var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvisoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35464 4.48291L8.22331 9.31184H6.99082L6.85612 4.48291H8.35464ZM7.60706 11.467C7.38481 11.467 7.19399 11.3884 7.0346 11.2313C6.8752 11.0719 6.79663 10.8811 6.79887 10.6588C6.79663 10.4388 6.8752 10.2502 7.0346 10.0931C7.19399 9.93595 7.38481 9.85737 7.60706 9.85737C7.82034 9.85737 8.00779 9.93595 8.16943 10.0931C8.33107 10.2502 8.41301 10.4388 8.41525 10.6588C8.41301 10.807 8.37372 10.9428 8.29739 11.0663C8.22331 11.1875 8.12565 11.2852 8.00442 11.3593C7.8832 11.4311 7.75074 11.467 7.60706 11.467Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9441 11.5374L8.19549 1.58046C7.95216 1.159 7.34384 1.15901 7.10051 1.58046L1.35189 11.5374C1.10856 11.9588 1.41273 12.4856 1.89938 12.4856H13.3966C13.8833 12.4856 14.1874 11.9588 13.9441 11.5374ZM9.29046 0.948277C8.56048 -0.316091 6.73552 -0.316093 6.00554 0.948275L0.25692 10.9052C-0.473063 12.1695 0.439412 13.75 1.89938 13.75H13.3966C14.8566 13.75 15.7691 12.1695 15.0391 10.9052L9.29046 0.948277Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvisoIcon);
export default __webpack_public_path__ + "static/media/aviso_icon.3afc22ba7875a98e843a57e2e98cb219.svg";
export { ForwardRef as ReactComponent };